var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarHalf = function SvgStarHalf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 122.88 116.864"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "star-half_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "50%",
    height: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m61.44 0 16.911 41.326 44.529 3.312-34.077 28.853 10.609 43.373L61.44 93.371l-37.972 23.493 10.61-43.373L0 44.638l44.529-3.312z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "gold",
    d: "m61.44 0 16.911 41.326 44.529 3.312-34.077 28.853 10.609 43.373L61.44 93.371l-37.972 23.493 10.61-43.373L0 44.638l44.529-3.312z",
    clipPath: "url(#star-half_svg__a)"
  })));
};
export default SvgStarHalf;